module.exports = __webpack_public_path__ + "static/media/webTemplate4.4d85e298.gif";